import { Component } from '@angular/core';
import { FieldBaseComponent } from '@shared/components/forms/components/field-base';
import { FormFieldErrorComponent } from '@shared/components/forms/components/form-field-error/form-field-error.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lib-form-toggle',
  styleUrls: ['form-toggle.component.scss'],
  templateUrl: 'form-toggle.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    FormFieldErrorComponent,
  ],
})
export class FormToggleComponent extends FieldBaseComponent {

  public changeValue(name: string | undefined): void {
    if (!name) {
      return;
    }

    const value: Record<string, any> = {};
    value[name] = !this.formGroup?.value[name];
    this.formGroup?.patchValue(value);
    this.formGroup?.updateValueAndValidity();
  }

  public onChange($event: Event) {
    if (this.config?.onToggleChange) {
      this.config.onToggleChange(($event.target as HTMLInputElement).checked);
    }
  }
}
